<template>
  <div>
    <div class="my-3">
      <p>
        Total Links: {{ allLinks.length / 2 }} Image(s) Missing Alt-Attributes: {{ missingAlt }} Broken Links: {{ brokenLinks }}
      </p>
    </div>
    <loading-spinner
      v-if="isLoading"
      custom-id="loading_spinner_all_links_and_images"
      :loading-status="isLoading"
    />
    <div
      class="my-3"
    >
      <ejs-grid
        :data-source="allLinks"
        :allow-paging="true"
        :page-settings="pageSettings"
        clip-mode="EllipsisWithTooltip"
        :row-template="rowTemplate"
      >
        <e-columns>
          <e-column
            field=" "
            header-text="Count"
            width="70"
          />
          <e-column
            field=" "
            header-text="Type"
          />
          <e-column
            field="link"
            header-text="Has Image Inside?"
          />
          <e-column
            field=" "
            header-text="Has text for ALT?"
          />
          <e-column
            field=" "
            header-text="Has Text Inside?"
          />
          <e-column
            field=" "
            header-text="Is Empty Link?"
          />
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import { GridPlugin, Page } from '@syncfusion/ej2-vue-grids'
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns'
import LoadingSpinner from '@/components/LoadingSpinner'

Vue.use(GridPlugin)
MultiSelect.Inject(CheckBoxSelection)

export default {
  components: {
    LoadingSpinner
  },
  provide () {
    return {
      grid: [Page]
    }
  },
  data () {
    return {
      missingAlt: 0,
      brokenLinks: 0,
      pageSettings: { pageCount: 5, pageSize: 25, pageSizes: ['10', '25', '50', '100'] },
      rowTemplate: () => {
        return {
          template: Vue.component('RowTemplate', {
            props: {
              countMissingAlt: {
                type: Function,
                required: false,
                default: this.countMissingAlt
              },
              countBrokenLink: {
                type: Function,
                required: false,
                default: this.countBrokenLink
              }
            },
            data: function () {
              const whiteList = [
                'facebook',
                'twitter',
                'instagram',
                'linkedin'
              ]
              return {
                data: {},
                whiteList,
                whiteListJoined: whiteList.join('|')
              }
            },
            mounted () {
              if (this.data.type === 'cols') {
                const htmlObject = this.getHTML()
                const a = htmlObject.querySelector('a')
                if (a) {
                  if (!a.alt) {
                    this.countMissingAlt()
                  }
                  if (a.href) {
                    const matches = a.href.match(new RegExp('\\b(' + this.whiteListJoined + ')\\b', 'ig'))
                    if (matches && matches.length === 0) {
                      axios.get(a.href, { withCredentials: true })
                        .then(({ status }) => {
                          if (status !== 200) {
                            this.countBrokenLink()
                          }
                        })
                        .catch(err => {
                          console.log(err)
                          this.countBrokenLink()
                        })
                    }
                  }
                }
              }
            },
            methods: {
              getHTML () {
                const htmlObject = document.createElement('div')
                htmlObject.innerHTML = this.data.value
                return htmlObject
              },
              getLink () {
                const htmlObject = this.getHTML()
                const a = htmlObject.querySelector('a')
                if (a && a.href) {
                  return a.href
                }
                return ''
              },
              getHasImageCell () {
                const htmlObject = this.getHTML()
                const img = htmlObject.querySelector('img')
                if (img && img.src) {
                  return '<span style="color: #658D30">Yes<span><br><a href="' + img.src + ' " target="_blank">View</a>'
                } else {
                  return '<span style="color: #A82823">No<span>'
                }
              },
              getHasTextForAltCell () {
                const htmlObject = this.getHTML()
                const a = htmlObject.querySelector('a')
                if (a && a.alt && a.alt.length) {
                  return '<span style="color: #658D30">Yes<span><br>' + a.alt
                } else {
                  return '<span style="color: #A82823">No<span>'
                }
              },
              getHasTextInsideCell () {
                const htmlObject = this.getHTML()
                const a = htmlObject.querySelector('a')
                if (a && a.innerText && a.innerText.length) {
                  return '<span style="color: #658D30">Yes<span><br>' + a.innerText
                } else {
                  return '<span style="color: #A82823">No<span>'
                }
              },
              getIsEmptyLinkCell () {
                const htmlObject = this.getHTML()
                const a = htmlObject.querySelector('a')
                if (a && a.innerHTML && a.innerHTML.length === 0) {
                  return '<span style="color: #658D30">Yes<span>'
                } else {
                  return '<span style="color: #A82823">No<span>'
                }
              }
            },
            template: `<tr>
              <td v-if="data.type === 'textarea'" class="e-rowcell e-ellipsistooltip"></td>
              <td v-if="data.type === 'textarea'" class="e-rowcell e-ellipsistooltip" colspan="5">
                <div class="form-group">
                  <textarea class="form-control allLinksAndImagesTextarea">
                    {{ data.value }}
                  </textarea>
                </div>
              </td>
              <td v-if="data.type === 'cols'" class="e-rowcell e-ellipsistooltip">
                {{ data.index > 0 ? data.index : '' }}
              </td>
              <td v-if="data.type === 'cols'" class="e-rowcell e-ellipsistooltip">
                <p>Image wrapped in A link</p>
                <p><a :href="getLink()">{{ getLink() }}</a></p>
              </td>
              <td v-if="data.type === 'cols'" class="e-rowcell e-ellipsistooltip">
                <div v-html="getHasImageCell()"></div>
              </td>
              <td v-if="data.type === 'cols'" class="e-rowcell e-ellipsistooltip">
                <div v-html="getHasTextForAltCell()"></div>
              </td>
              <td v-if="data.type === 'cols'" class="e-rowcell e-ellipsistooltip">
                <div v-html="getHasTextInsideCell()"></div>
              </td>
              <td v-if="data.type === 'cols'" class="e-rowcell e-ellipsistooltip">
                <div v-html="getIsEmptyLinkCell()"></div>
              </td>
            </tr>`
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'getLoadingStatus',
      allLinks: 'getAllLinks'
    })
  },
  mounted () {
    const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : ''
    const templateId = this.$route.params.id
    this.getAllLinks({ templateId, userEmail })
  },
  methods: {
    ...mapActions([
      'getAllLinks'
    ]),
    countMissingAlt () {
      this.missingAlt++
    },
    countBrokenLink () {
      this.brokenLinks++
    }
  }
}
</script>
<style lang="scss">
textarea.allLinksAndImagesTextarea {
  width: 100%;
}
</style>
